import { AfterContentInit, Directive, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';

@Directive({
  selector: '[appRipple]'
})
export class RippleDirective implements AfterContentInit {

  ripple;
  rippleContainer;
  rippleSpan;
  ripples = [];
  rippleDuration = 400;
  rippleExists;

  @ViewChild('appRipple') private returnedRippleContainer: ElementRef;

  constructor(private el: ElementRef,
              private renderer: Renderer2) {
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    this.showRipple(this.el.nativeElement);
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.cleanUp(this.el.nativeElement);
  }

  ngAfterContentInit() {
    this.rippleInit(this.el.nativeElement);
  }

  // Create ripple, forming from point mouse enters and ensure one doesn't already exist
  private showRipple(e) {

    this.rippleContainer = e.querySelector('.ripple--container');
    this.rippleSpan = e.querySelector('.ripple--container span');

    if (this.rippleSpan === null) {
      let pos, ripple, size, style, x, y;
      ripple = this;
      const rippler = document.createElement('span');
      size = e.offsetWidth + 10;
      pos = ripple.el.nativeElement.getBoundingClientRect();
      x = (<any>event).pageX - pos.left - (size / 2);
      y = (<any>event).pageY - pos.top - (size / 2);
      style = 'top:' + y + 'px; left: ' + x + 'px; height: ' + size + 'px; width: ' + size + 'px;';
      this.renderer.appendChild(this.rippleContainer, rippler);
      setTimeout(function () {
        rippler.setAttribute('class', 'transform');
      }, 1);
      return rippler.setAttribute('style', style);
    }
  }

  // Shrink the ripple to the point where the mouse leaves
  private cleanUp(e) {
    this.rippleExists = this.rippleContainer.firstChild;

    if (this.rippleExists != null) {
      const shrinkRipple = e.querySelector('.ripple--container span');
      let pos, size, style, x, y;

      this.ripple = this.el.nativeElement;
      size = this.ripple.offsetWidth + 10;
      pos = this.ripple.getBoundingClientRect();
      x = (<any>event).pageX - pos.left - (size / 2);
      y = (<any>event).pageY - pos.top - (size / 2);

      style = 'top:' + y + 'px; left: ' + x + 'px; height: ' + size + 'px; width: ' + size + 'px;';
      shrinkRipple.setAttribute('style', style);
      shrinkRipple.classList.remove('transform');

      setTimeout(function () {
        shrinkRipple.remove();
      }, this.rippleDuration);
    }
  }

// Create listener for all 'ripples'
  rippleInit(e) {
    // Add Ripple to the array
    this.ripples.push(e);

    for (let i = 0, len = this.ripples.length; i < len; i++) {
      this.ripple = this.ripples[i];

      const childRippleContainer = document.createElement('div');
      childRippleContainer.classList.add('ripple--container');
      this.renderer.appendChild(this.ripple, childRippleContainer);
      this.ripple.rippleContainer = childRippleContainer;
      this.ripple.appendChild(childRippleContainer);
    }
  }
}
